import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import styled from '@emotion/styled'
import { useTheme } from '@mui/system'

import { Button, ButtonVariant } from 'src/system/ui/button/Button'
import {
  brighten,
  hoverAmount,
  hoverTransition
} from 'src/system/ui/theme/hover'

export function MissingMatchesSupport() {
  const { t } = useTranslation()
  const theme = useTheme()
  const [visible, setVisible] = useState(false)

  const open = () => setVisible(true)
  const close = () => setVisible(false)

  const discordUrl = t('social:discord:link')
  const emailUrl = t('link:contact')

  const handleDiscord = () => {
    window.open(discordUrl, '_blank', 'noopener,noreferrer')
    close()
  }

  const handleEmail = () => {
    window.location.href = emailUrl
    close()
  }

  return (
    <>
      <Prompt>
        {t('matches:tell_support:prompt')}{' '}
        <Trigger type='button' onClick={open}>
          {t('matches:tell_support:action')}
        </Trigger>
      </Prompt>

      <Dialog open={visible} onClose={close}>
        <DialogContent>
          <DialogTitle>{t('matches:tell_support:modal:title')}</DialogTitle>
          <DialogContentText>
            {t('matches:tell_support:modal:body')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={handleEmail} variant={ButtonVariant.secondary}>
            {t('matches:tell_support:modal:email_button')}
          </StyledButton>
          <StyledButton
            onClick={handleDiscord}
            variant={ButtonVariant.primary}
            color={theme.d.colors.discord.blurple}
          >
            {t('matches:tell_support:modal:discord_button')}
          </StyledButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

const Prompt = styled.p`
  font-size: 14px;
  margin: ${(props) => props.theme.d.spacing[2]} 0 0;
  color: ${(props) => props.theme.d.colors.text.secondary};
`

const Trigger = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  cursor: pointer;
  color: ${(props) => props.theme.d.colors.link.default};
  transition: color ${hoverTransition};

  &:hover {
    color: ${(props) =>
      brighten(props.theme.d.colors.link.default, hoverAmount.text)};
    text-decoration: underline;
  }
`

const StyledButton = styled(Button)`
  text-transform: uppercase;
`
